import { FunctionComponent } from 'react';

import { ArrowUpIcon } from '../Arrow/ArrowUp.icon';
import { IconPropsInterface } from '../Icon.types';

const ChevronUpIcon: FunctionComponent<IconPropsInterface> = ({
  color = 'black',
  size = '24px',
  ...rest
}) => <ArrowUpIcon size={size} color={color} {...rest} />;

ChevronUpIcon.displayName = 'ChevronUpIcon';

export default ChevronUpIcon;
